export namespace RifoTamplateStates {

    export enum ERifoTemplates {
        Default = 'default',
        Demo = 'demo',
        Epic = 'epic'
    }

    export function rifoTemplateStatesFactory() {
        const rifoTemplate = {
            template: ERifoTemplates.Default,
            timestamp: new Date()
        };
        return rifoTemplate;
    }

    export function mutations() {
        return {
            setTemplate(state: any, template: ERifoTemplates) {
                state.rifoTemplate.timestamp = new Date();
                state.rifoTemplate.template = template;
            }
        };
    }
}
